import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// import { Dropdown, Option } from "./Dropdown";
import { Form, Button } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import Toggle from "react-toggle";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Checkbox, TextareaAutosize, TextField } from "@mui/material";

import { format } from "date-fns";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const ViewCustomers = ({ history, match }) => {
  const [dap_users, setUsers] = useState([]);
  const [dap_users1, setUsers1] = useState([]);
  // const [users, setUsers] = useState({});
  const [dap_name, setName] = useState("");
  const [dap_date, setDate] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_dob, setDOB] = useState("");
  const [Package, setPackage] = useState("");
  const [dap_billable, setBillable] = useState(false);
  const [dap_billable1, setBillable1] = useState(false);
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [region, setRegion] = useState("");
  const [loading, setLoading] = useState(false);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [emailErrors, setEmailErrors] = useState({});
  const [nameErrors, setNameErrors] = useState({});
  const [toggleChecked, setToggleChecked] = useState(false);
  const [phoneErrors, setPhoneErrors] = useState({});
  const [leadExecutiveName, setLeadExecutiveName] = useState("");
  const [leadExecutiveId, setLeadExecutiveId] = useState("");

  const [assigned_to, setAssignedto] = useState("");
  const dap_user_id = match.params.id;
  const { SearchBar } = Search;
  const toggle = (e) => {
    setToggleChecked(true);
  };
  const [goBackLink, setGoBackLink] = useState("");

  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  states = State.getAllStates();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };

  let id = match.params.id;

  console.log(id);

  const getUser = (uid) => {
    // console.log(,uid);
    axios
      .get(environment.dap_url + "users/getUserById?id=" + uid)
      .then((res) => {
        const dap_users = res.data;
        console.log(res);
        console.log("polo inside", res.data);
        console.log("hello");

        // setUsers(res.data);
        let d = res.data.note;
        console.log(d.parentId);

        setEmail(d.email);
        setName(d.userFirstName + " " + d.userLastName);
        setPhone(d.phone);
        setAddress(d.address);
        setPostCountry(d.country);
        setPostState(d.state);
        setPostCity(d.city);
        setDate(d.date);
        setBillable(d.isBillable);

        setZip(d.zip);
        setPackage(d.package);

        axios
          .get(environment.dap_url + "users/getUserById?id=" + d.parentId)
          .then((response) => {
            console.log("polo inside", response);
            if (!response.data.note) {
              setAssignedto("");
            } else {
              setAssignedto(
                response.data.note.userFirstName +
                  " " +
                  response.data.note.userLastName
              );
            }
          })
          .catch(function (error) {
            MySwal.fire({
              title: <p>{error.message}</p>,
              type: "error",
            });
          });

        //if (res.data.details[0]) {
        // console.log(res.data.details[0].userFirstName);
        // setLeadExecutiveName(res.data.details[0].userFirstName + " " + res.data.details[0].userLastName)
        //     setLeadExecutiveId(res.data.details[0]._id)
        //     // console.log(res.data.details[0]._id);

        if (localStorage.getItem("isLeadExecutive")) {
          // getFollowUpByLeadId
          axios
            .post(
              environment.dap_url +
                "crm_api/getFollowUpByLeadExecutiveIdandLeadId",
              {
                lead_executive_id: d.createdBy,
                lead_id: id,
              }
            )

            .then((resp) => {
              // const dap_users = resp.data;
              console.log(res);
              console.log(resp);
              setUsers(resp.data);
              console.log(resp.data.length);
              // setPackageLabel(res.data[res.data.length-1].label)
              // setPackagePrice(res.data[res.data.length-1].package)
            })

            .catch(function (error) {
              MySwal.fire({
                title: <p>{error.message}</p>,
                type: "error",
              });
            });
        } else {
          console.log(d.email);
          axios
            .post(environment.dap_url + "crm_api/getFollowUpByEmail", {
              email: d.email,
            })
            .then((resp) => {
              // const dap_users = resp.data;
              console.log("res");
              console.log(resp);
              setUsers(resp.data);
              console.log(resp.data.length);
              // setPackageLabel(res.data[res.data.length-1].label)
              // setPackagePrice(res.data[res.data.length-1].package)
            })
            .catch(function (error) {
              MySwal.fire({
                title: <p>{error.message}</p>,
                type: "error",
              });
            });
        }

        // }

        axios
          .post(environment.dap_url + "support/getTicketByCustomer", {
            email: d.email,
          })
          .then((resp) => {
            const dap_users1 = resp.data;
            console.log(resp.data);
            setUsers1(resp.data);

            // setPackageLabel(res.data[res.data.length-1].label)
            // setPackagePrice(res.data[res.data.length-1].package)
          })
          .catch(function (error) {
            MySwal.fire({
              title: <p>{error.message}</p>,
              type: "error",
            });
          });

        // setLoader(false);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };

  //   console.log(Country.getAllCountries());
  //   console.log(Country.getAllCountries());
  //   console.log(State.getAllStates());
  useEffect(() => {
    let id = match.params.id;
    //  console.log(id);getLead(id);
    console.log("polosghfy");
    console.log("polo", id);

    if (localStorage.getItem("isLeadExecutive")) {
      setGoBackLink("/get-leads");
    } else {
      setGoBackLink("/customers");
    }
    getUser(id);
    setLoading(true);
    console.log(id);
  }, []);

  const formValidation = () => {
    const emailErrors = {};
    const nameErrors = {};
    const phoneErrors = {};

    let isValid = true;

    if (!dap_email) {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(dap_email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
    }
    if (!dap_name) {
      nameErrors.noName = "* Name is required";
      isValid = false;
    } else if (dap_name.trim().length < 2) {
      nameErrors.shortName = "* First Name is too short";
      isValid = false;
    }
    if (!dap_phone) {
      phoneErrors.shortNumber = "* Phone number required";
      isValid = false;
    } else if (dap_phone.trim().length < 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (dap_phone.trim().length > 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,1024}$/.test(
        dap_phone
      )
    ) {
      phoneErrors.shortNumber = "Phone number should be 10 digits";
      isValid = false;
    }

    setEmailErrors(emailErrors);
    setNameErrors(nameErrors);
    setPhoneErrors(phoneErrors);
    return isValid;
  };

  const handlechange_new = (e) => {
    console.log(e.target.value);
    if (e.target.id == "yes") {
      setBillable(!dap_billable);
    } else {
      setBillable(dap_billable);
    }
  };

  const submitHandler = (e) => {
    const isValid = formValidation();
    e.preventDefault();
    setLoading(true);
    let id = match.params.id;
    console.log(id);
    axios
      .put(
        //"user?sendActivationMail=true",
        environment.dap_url + "crm_api/updateLead?id=" + id,
        {
          // id: match.params.id,
          name: dap_name,
          email: dap_email,
          phone: dap_phone,
          city: postcity,
          state: poststate,
          country: postcountry,
          address: dap_address,
          zip: zip,
          billable: dap_billable,
          date: dap_date,
          //   userType: "LOGISTIC_MANAGER",
        }
      )
      .then((res) => {
        console.log("hello", res.data);
        history.push("/addleads");
        MySwal.fire({
          title: <p>Lead has been successfully updated!</p>,
          type: "success",
        });
        //   history.push(`/users/${dap_user_id}`);
      })
      .catch((err) => {
        setLoading(false);
        MySwal.fire({
          title: <p>{err?.response?.data?.message || "Lead update failed"}</p>,
          type: "error",
        });
      });
  };

  let columns;
  if (localStorage.getItem("isLeadExecutive")) {
    columns = [
      {
        dataField: "sl.no",
        text: "Sl no.",
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return rowIndex + 1;
        },
        sort: true,
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
      },
      {
        dataField: "note",
        text: "Note",
        sort: true,
      },
      {
        dataField: "mode",
        text: "Mode",
        sort: true,
      },
      {
        dataField: "createdAt",
        text: "Created At",
        sort: true,
        formatter: (dataField) => {
          // return (
          //   dataField.userFirstName+' '+dataField.userLastName
          // )
          let dateTimeArr = dataField.split("T");
          let dateArr = dateTimeArr[0].split("-");
          let dateFinal = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
          return dateFinal;
        },
      },
    ];
  } else {
    columns = [
      {
        dataField: "sl.no",
        text: "#",
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return rowIndex + 1;
        },
        sort: true,
      },
      {
        dataField: "date",
        text: "Date",
        sort: true,
      },
      {
        dataField: "note",
        text: "Note",
        sort: true,
      },
      {
        dataField: "mode",
        text: "Mode",
        sort: true,
      },
      {
        dataField: "details[0]",
        text: "Lead Executive",
        sort: true,
        formatter: (dataField) => {
          return dataField.userFirstName + " " + dataField.userLastName;
        },
      },
    ];
  }

  let columns1;
  columns1 = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },

    {
      dataField: "createdAt",
      formatter: (dataField) => {
        return dataField.split("T")[0];
      },
      text: "Date",
      sort: true,
    },
    {
      dataField: "ticketId",
      text: "TicketId",
      sort: true,
    },
    {
      dataField: "_id",
      text: "Assigned To",
      formatter: (cell, row, rowIndex, dataField, formatExtraData) => {
        console.log("executive details", row.executive_details);
        if (row.executive_details == "") {
          return "";
        }
        if (row.executive_details.length > 0) {
          return (
            row.executive_details[0].userFirstName +
            " " +
            row.executive_details[0].userLastName
          );
        } else {
          return "";
        }
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  return (
    <div>
      <div className="container-fluid">
        <NavbarNew />
        <Link to={goBackLink} className="btn btn-light my-3">
          Go Back
        </Link>
      </div>

      <div className="container-fluid">
        <h4 className="card-title">Customer Details</h4>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th scope="row">Name</th>

              <td>{dap_name}</td>
            </tr>
            {/* <tr>
                      <th scope="row">Date</th>
                      <td>{dap_date}</td>
                    </tr> */}
            <tr>
              <th scope="row">Email</th>
              <td>{dap_email}</td>
            </tr>
            <tr>
              <th scope="row">Phone</th>
              <td>{dap_phone}</td>
            </tr>
            <tr>
              <th width="50%" scope="row">
                Country
              </th>
              <td>{postcountry}</td>
            </tr>
            <tr>
              <th scope="row">State</th>
              <td>{poststate}</td>
            </tr>
            <tr>
              <th scope="row">City</th>
              <td>{postcity}</td>
            </tr>
            <tr>
              <th scope="row">Address</th>
              <td>{dap_address}</td>
            </tr>
            <tr>
              <th scope="row">Zip Code</th>
              <td>{zip}</td>
            </tr>
            <tr>
              <th scope="row">Partner Name</th>
              <td>{assigned_to}</td>
            </tr>
            {Package == undefined ? (
              ""
            ) : Package == "" ? (
              ""
            ) : (
              <tr>
                <th scope="row">Package</th>
                <td>{Package}</td>
              </tr>
            )}
            <tr>
              <th scope="row">Billable</th>
              {dap_billable ? <td>Yes</td> : <td>No</td>}
            </tr>
          </tbody>
        </table>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <h4 style={{ margin: "20px" }}>Follow Ups</h4>
                <div className="col-12">
                  <ToolkitProvider
                    keyField="id"
                    bootstrap4
                    data={dap_users}
                    columns={columns}
                    search
                  >
                    {(props) => (
                      <div>
                        <div className="d-flex align-items-center">
                          <p className="mb-2 mr-2">Search in table:</p>
                          <SearchBar {...props.searchProps} />
                        </div>
                        <BootstrapTable
                          defaultSorted={defaultSorted}
                          // pagination={paginationFactory()}
                          {...props.baseProps}
                          wrapperClasses="table-responsive"
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <h4 style={{ margin: "20px" }}>Support Tickets Raised</h4>
                <div className="col-12">
                  <ToolkitProvider
                    keyField="id"
                    bootstrap4
                    data={dap_users1}
                    columns={columns1}
                    search
                  >
                    {(props) => (
                      <div>
                        <div className="d-flex align-items-center">
                          <p className="mb-2 mr-2">Search in table:</p>
                          <SearchBar {...props.searchProps} />
                        </div>
                        <BootstrapTable
                          defaultSorted={defaultSorted}
                          // pagination={paginationFactory()}
                          {...props.baseProps}
                          wrapperClasses="table-responsive"
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCustomers;
